var exports = {
  "w": "SidePanel__RGvnRQ",
  "O": "HiddenSidePanel__B93C-7",
};

module.exports = exports;
